import React, {Component} from 'react';
import PropTypes from 'prop-types';
import JobInputTitle from './JobInputTitle';
import JobListSelectField from './JobListSelectField';

const listInputStyles = {
    container: {margin: '0 0 1em 0'}
};

class JobSingleFromListInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addedIDs: [],
            addedItems: [],
            selectedItem: (props.defaultValue) ? props.defaultValue : null
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.reset && !this.props.reset) {
            this.setState({
                addedIDs: [],
                addedItems: [],
                selectedItem: null
            });
        }
    }

    handleSelectItem = (type, selected) => {
        let selectedItem = (selected && selected.id) ? selected : null;

        this.setState({
            selectedItem: selectedItem
        }, () => {
            if (typeof this.props.onItemSelect === 'function') {
                let nativeType = this.props.nativeType;
                let value;
                if (selectedItem) {
                    if (nativeType === 'str') {
                        value = selectedItem[this.props.returnKey].toString();
                    } else {
                        value = parseInt(selectedItem.id, 10);
                    }
                } else {
                    value = (nativeType === 'str') ? '' : null;
                }
                this.props.onItemSelect(this.props.customType, this.props.name, value);
            }
        });
    };

    render() {
        const {
            customType,
            defaultValue,
            label,
            param,
            required,
            returnKey,
            tooltip
        } = this.props;

        return (
            <div style={listInputStyles.container}>
                <JobInputTitle label={label} tooltip={tooltip}/>

                <JobListSelectField
                    label={label}
                    customType={customType}
                    param={param}
                    selectionType="object"
                    returnKey={returnKey}
                    required={required}
                    onSelectItem={this.handleSelectItem}
                    defaultValue={defaultValue}
                />
            </div>
        )
    }
}

const defaultPropType = PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
]);

JobSingleFromListInput.propTypes = {
    customType: PropTypes.string,
    defaultValue: defaultPropType,
    label: PropTypes.string,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onItemSelect: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    reset: PropTypes.bool,
    returnKey: PropTypes.string,
    tooltip: PropTypes.string
};

JobSingleFromListInput.defaultProps = {
    defaultValue: [],
    name: 'location',
    param: 'location',
    nativeType: 'str',
    required: false,
    reset: false,
    returnKey: 'id'
};

export default JobSingleFromListInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobSingleFromListInput.js